import React from "react";
import Pagination from "react-bootstrap/Pagination";

const PaginationComponent = ({ currentPage, totalPages, onPageChange, totalEntries, entriesPerPage }) => {

    const adjustedCurrentPage = currentPage + 1;

    const handlePageClick = (page) => {
        if (page !== adjustedCurrentPage) {
            onPageChange(page - 1);
        }
    };

    const getVisiblePages = () => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        
        const pages = [];
        pages.push(1, 2);
        
        if (adjustedCurrentPage > 4) {
            pages.push('...');
        }
        
        const start = Math.max(3, adjustedCurrentPage - 1);
        const end = Math.min(totalPages - 2, adjustedCurrentPage + 1);
        
        for (let i = start; i <= end; i++) {
            if (i > 2 && i < totalPages - 1) {
                pages.push(i);
            }
        }
        
        if (adjustedCurrentPage < totalPages - 3) {
            pages.push('...');
        }
        
        pages.push(totalPages - 1, totalPages);
        return [...new Set(pages)];
    };

    const startEntry = (adjustedCurrentPage - 1) * entriesPerPage + 1;
    const endEntry = Math.min(adjustedCurrentPage * entriesPerPage, totalEntries);

    return (
        <div className="pagination-section">
            <div className="showing-user">
                <p>
                    Showing {startEntry} to {endEntry} of {totalEntries} entries
                </p>
            </div>
            <div className="pagination-block">
                <Pagination>
                    <Pagination.First
                        onClick={() => handlePageClick(1)}
                        disabled={adjustedCurrentPage === 1}
                    />
                    <Pagination.Prev
                        onClick={() => handlePageClick(adjustedCurrentPage - 1)}
                        disabled={adjustedCurrentPage === 1}
                    />
                    {getVisiblePages().map((page, index) => (
                        page === '...' ? (
                            <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                        ) : (
                            <Pagination.Item
                                key={page}
                                active={page === adjustedCurrentPage}
                                onClick={() => handlePageClick(page)}
                            >
                                {page}
                            </Pagination.Item>
                        )
                    ))}
                    <Pagination.Next
                        onClick={() => handlePageClick(adjustedCurrentPage + 1)}
                        disabled={adjustedCurrentPage === totalPages}
                    />
                    <Pagination.Last
                        onClick={() => handlePageClick(totalPages)}
                        disabled={adjustedCurrentPage === totalPages}
                    />
                </Pagination>
            </div>
        </div>
    );
};

export default PaginationComponent;
